import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "../api";
import markup from "ulysses/controls/fieldtree.html";

$(document).ready(function () {
    $(markup).appendTo($("body"));
});

function fetch_model_data(resource_or_name, prefix, options) {
    var resource;
    // console.log("resource:", resource);
    var result = Promise.Deferred();
    if (!resource_or_name) {
        result.reject(null);
        return result;
    }
    
    if (resource_or_name._links) {
        resource = HalResource(resource_or_name);
    } else if (resource_or_name === "__login") {
        resource = uly.api.start().follow("uly:models").follow("find", {
            "rel": "contact"
        });
    } else if (typeof resource_or_name === "string") {
        resource = uly.api.start().follow("uly:models").follow("find", {
            "rel": resource_or_name
        });
    } else if (ko.unwrap(resource_or_name.name)) {
        resource = uly.api.start().follow("uly:models").follow("find", {
            "rel": ko.unwrap(resource_or_name.name)
        });
    }
    if (!resource) {
        result.reject(null);
        return result;
    }
    // console.log("resource:", resource);
    resource.has_rel("uly:attributes").done(function (attributes) {
        var res = null;
        if (!attributes) {
            res = HalResource(resource.resource._links.self.href);
        } else {
            res = resource;
        }
        Promise.when(res.follow("uly:attributes"), res.follow("uly:favourites"), res.follow("uly:relations"))
               .done(function ([attributes, favourites, relations]) {
            var final_data = {
                "attributes": $.map(attributes, function (val) {
                    val.key = (prefix || resource.resource.name) + "." + val.name;
                    if (!options.show_attrs) {
                        return null;
                    }
                    return val;
                }).sort(function (a, b) {
                    return a.key < b.key ? -1 : a.key > b.key ? 1 : 0;
                }),
                // "favourites": $.map(favourites, function (val, idx) {
                //     // console.log("val: ", val);
                //     // console.log("idx: ", idx);
                //     val.key = (prefix || resource.resource.name) + "." + val.name;
                //     if (!options.show_attrs) {
                //         return null;
                //     }
                //     return val;
                // }).sort(function (a, b) {
                //     return a.key < b.key ? -1 : a.key > b.key ? 1 : 0;
                // }),
                "relations": $.map(relations, function (val, idx) {
                    val.expanded = ko.observable(false);
                    val.attributes = ko.observableArray([]);
                    val.relations = ko.observableArray([]);

                    if (
                        (ko.unwrap(val.multiplicity) === "one" && !options.single_rels) ||
                        (ko.unwrap(val.multiplicity) === "many" && !options.many_rels)
                    ) {
                        return null;
                    }
                    val.key = (prefix || resource.resource.name) + "." + val.name;
                    return val;
                }).sort(function (a, b) {
                    return a.key < b.key ? -1 : a.key > b.key ? 1 : 0;
                })
            };
            result.resolve(final_data);
        }).fail(function (error) {
            result.reject(error);
        });
    }).fail(function (error) {
        result.reject(error);
    });
    return result;
}

function fetch_model_favourites(resource_or_name, options) {
    var resource;
    var resource_name;
    console.log("resource_or_name:", resource_or_name);
    var result = Promise.Deferred();
    if (!resource_or_name) {
        result.reject(null);
        return result;
    }
    if (resource_or_name._links) {
        resource = HalResource(resource_or_name);
    } else if (typeof resource_or_name === "string") {
        resource = uly.api.start().follow("uly:models").follow("uly:favourites").follow("find", {
            "rel": resource_or_name
        });
        resource_name = resource_or_name;
    } else if (ko.unwrap(resource_or_name.name)) {
        resource = uly.api.start().follow("uly:models").follow("uly:favourites").follow("find", {
            "rel": ko.unwrap(resource_or_name.name)
        });
        resource_name = resource_or_name.name;
    }
    if (!resource) {
        result.reject(null);
        // console.log("result:", result);
        return result;
    }
    // console.log("resource:", resource);
    // console.log("resource_name:", resource_name);
    resource.then(function (res) {
        var final_data = {
            "favourites": $.map(res["favourites"], function (val, idx) {
                if (resource_or_name.key === "__login") {
                    val.caption = "(Logged In) - " + (val.caption || val.name);
                } else {
                    val.caption = "(" + resource_name + ") - " + (val.caption || val.name);
                };
                val.key = resource_name + "." + val.name;
                
                return val;
            }).sort(function (a, b) {
                return a.key < b.key ? -1 : a.key > b.key ? 1 : 0;
            }),
        };
        let favs = final_data["favourites"] || [];
        favs.unshift({
            "caption": _("favourites_today", "Today"),
            "key": '"{0:medium}".format(today)'
        });
        favs.unshift({
            "caption": _("favourites_now", "Now"),
            "key": '"{0:medium}".format(now)'
        });
        result.resolve(favs);
    }).fail(function (e) {
        result.reject(e);
    });

    // console.log("result:", result);
    return result;
}

uly.actions.selectfield = function (ev, $elt, ui) {
    console.log("got data:", ui);
    // console.log("key = ", key)
    var key = ko.unwrap(ui.model.key)
    console.log("selected key:", key);
    ui.context.$parents[ui.context.$parents.length - 2].selected(key);
    return false;
};

uly.actions.expandrelationfield = function (ev, $elt, ui) {
    var data = ui.model;
    // console.log("uly.actions.expandrelationfield data:", data);
    var name = ko.unwrap(data.name);
    if (!name) {
        return false;
    }

    var mainContext = ui.context.$parents[ui.context.$parents.length - 2];
    // console.log("main context:", mainContext);
    var options = {
        many_rels: ko.unwrap(mainContext.many_rels) === true,
        single_rels: ko.unwrap(mainContext.single_rels) !== false,
        traverse_single: ko.unwrap(mainContext.traverse_single) !== false,
        traverse_many: ko.unwrap(mainContext.traverse_many) !== false,
        show_attrs: ko.unwrap(mainContext.show_attrs) !== false
    };
    if (!ko.unwrap(data.expanded)) {
        $elt.removeClass("fa-plus").addClass("fa-minus");
        var def = null;
        if (name === "__login") {
            def = fetch_model_data("__login", "__login", options);
        } else {
            // console.log("data = ", data)
            def = fetch_model_data(ko.unwrap(data), ko.unwrap(ko.unwrap(data).key), options);
        }
        def.done(function (result) {
            if (ko.isObservable(data.attributes)) {
                data.attributes(result.attributes);
            }
            if (ko.isObservable(data.relations)) {
                data.relations(result.relations);
            }
            // if (ko.isObservable(data.favourites)) {
            //     data.favourites(result.favourites);
            // }
        });
        data.expanded(true);
    } else {
        data.expanded(false);
        $elt.removeClass("fa-minus").addClass("fa-plus");
    }
    return false;
};

ko.bindingHandlers.modelfieldpicker = {
    "select_field": function (options, extraRoots) {
        var entity = ko.unwrap(options.entity);
        var roots = [];
        var favourites = [];
        var total_def = null;

        var defs = [];
        if (extraRoots) {
            $.each(extraRoots, function (idx, val) {
                var def = fetch_model_favourites(val, options);
                defs.push(def);
                def.then(function (result) {
                    // console.log("result = ", result);
                    favourites = result;
                    // console.log("favourites = ", ko.unwrap(favourites));
                    $.extend(true, val, {
                        "name": val.name,
                        "caption": val.caption,
                        "key": val.key,
                        "relations": [],
                        "attributes": [],
                        "favourites": favourites,
                        "expanded": false
                    });
                    // roots.push();
                    roots.push(val);
                });
            });
        }

        if (entity) {
            if (typeof entity == "string") {
                if (entity.indexOf(",") > 0) {
                    entity = entity.split(",");
                } else {
                    entity = [entity];
                }
            }
            $.each(entity, function (idx, root) {
                var def = fetch_model_favourites(root, options);
                defs.push(def);
                def.then(function (result) {
                    // console.log("result = ", result);
                    favourites = result;
                    // console.log("favourites = ", ko.unwrap(favourites));
                    roots.push({
                        "name": root,
                        "caption": root,
                        "key": root,
                        "relations": [],
                        "attributes": [],
                        "favourites": favourites,
                        "expanded": false
                    });

                    return result;
                });

                // console.log("roots = ", roots);
            });
        }
        
        total_def = Promise.when.apply($, defs);
        if (!total_def) {
            total_def = Promise.Deferred();
            total_def.resolve([]);
        }
        return total_def.then(function (results) {

            console.log(roots.map((r) => $.extend({}, r)));
            return uly.dialogs.execute($("#model-field-picker").html(), {
                "title": _("model_title_select_data_field", "Select data field")
            }, {
                "roots": roots,
                "many_rels": false,
                selected: ko.observable(options.path || null)
            });
        });
    },
    "init": function (elt, va, allbindings, model, context) {
        var res = ko.bindingHandlers.value.init(elt, va, allbindings, model, context);
        $(elt).parent().children().click(function () {
            //open the data field picker dialog.
            var modeloptions = ko.unwrap(allbindings().modeloptions) || {};
            var currentPath = ko.unwrap(va());
            modeloptions = $.extend({}, modeloptions, {
                "path": currentPath
            });
            var entity = ko.unwrap(modeloptions.root_entity);
            if (entity != null && entity[0] === "?") {
                var tokens = entity.slice(1).split(".");
                var cval = context.$data;
                $.each(tokens, function (idx, val) {
                    if (val === "$parent") {
                        cval = context.$parent;
                    } else if (val === "$data") {
                        cval = context.$data;
                    } else {
                        cval = ko.unwrap(cval[val]);
                    }
                });
                entity = ko.unwrap(cval);
            }
            var newoptions = $.extend({}, modeloptions, {
                "entity": entity
            });
            if (currentPath && entity) {
                newoptions.path = entity + "." + currentPath;
            }
            ko.bindingHandlers.modelfieldpicker.select_field(newoptions).then(function ([result]) {
                var res = ko.unwrap(result.selected);
                if (res) {
                    if (res.indexOf(entity) === 0) {
                        res = res.substring(entity.length + 1);
                    }
                    var obs = va();
                    if (ko.isObservable(obs)) {
                        obs(res);
                    }
                }
            });
        });
        return res;
    },
    "update": function (elt, va, allbindings, model, context) {
        return ko.bindingHandlers.value.update(elt, va, allbindings, model, context);
    }
};

ko.bindingHandlers.expressionpicker = {
    "init": function (element, va, allBindings, viewModel, bindingContext) {
        var modeloptions = ko.unwrap(allBindings().modeloptions) || {};
        var $bt = $(element).next(".button").click(function (ev, ui) {
            ev.preventDefault();
            var value = ko.toJS(va());
            if (typeof value != "undefined" && value != null && !Object.isObject(value))
                value = {
                    "expression": value,
                    "kind": "field"
                };
            var currentopts = $.extend({}, modeloptions, value);
        });
        $(element).add($bt).click(function (ev, ui) {
            ev.preventDefault();
            var value = ko.toJS(va());
            if (typeof value != "undefined" && value != null && !Object.isObject(value))
                value = {
                    "expression": value,
                    "kind": "field"
                };
            var currentopts = $.extend({}, modeloptions, value);
            $.crimson.dialog({
                "url": "/model/expressiondlg",
                "buttons": {
                    "Ok": function () {
                        $(this).dialog("close");
                    }
                }
            }, currentopts).done(function (ev, dummy, data) {
                var res = null,
                    result = null;
                if (typeof data.viewdata != "undefined" && data.viewdata.path)
                    res = data.viewdata;
                else res = data;
                // console.log("got result:", res);
                if (res.kind == "constant")
                    result = {
                        "kind": "constant",
                        "expression": res.constant
                    };
                else if (res.kind == "script")
                    result = {
                        "kind": "script",
                        "expression": res.script
                    };
                else if (res.kind == "!field")
                    result = {
                        "kind": "!field",
                        "expression": res.path
                    };
                else
                    result = {
                        "kind": "field",
                        "expression": res.path
                    };
                var valAc = va();
                //console.log("valac:", valAc);
                if (typeof valAc == "function") {
                    //console.log("setting value:", result);
                    va()(result);
                    //hack to make sure things work
                    va().notifySubscribers();
                } else if (Object.isObject(valAc)) {
                    if (typeof valAc.kind == "function")
                        valAc.kind(result.kind);
                    else valAc.kind = ko.observable(result.kind);
                    if (typeof valAc.expression == "function")
                        valAc.expression(result.expression);
                    else valAc.expression = ko.observable(result.expression);
                }
            });
            return false;
        }).change(function () {
            var newexp = $(element).value();
            var val = ko.toJS(ko.utils.unwrapObservable(va()));
            if (newexp == null || newexp == "")
                val.expression = "";
            else {
                if (newexp[0] == "=")
                    val = {
                        "kind": "script",
                        "expression": newexp.slice(1)
                    };
                else if (newexp[0] == "?") {
                    if (newexp[1] == "1")
                        val = {
                            "kind": "!field",
                            "expression": newexp.slice(2)
                        };
                    else
                        val = {
                            "kind": "field",
                            "expression": newexp.slice(1)
                        };
                } else val = {
                    "kind": "constant",
                    "expression": newexp
                };
                va()(val);
            }
        });
    },
    "update": function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        var val = ko.toJS(ko.utils.unwrapObservable(valueAccessor()));
        if (typeof val != "undefined" && val != null && !Object.isObject(val))
            val = {
                "expression": val,
                "kind": "field"
            };
        else if (typeof val == "undefined" || val == null)
            val = {
                "expression": null,
                "kind": "field"
            };

        if (val.kind == "constant")
            $(element).val(val.expression);
        else if (val.kind == "script")
            $(element).val("=" + val.expression);
        else if (val.kind == "!field") {
            if (val.expression != null)
                $(element).val("?!" + val.expression);
            else $(element).val("");
        } else {
            if (val.expression != null)
                $(element).val("?" + val.expression);
            else $(element).val("");
        }
        var $bt = $(element).next("a.button");
        if (val.expression != null && val.expression != "")
            $bt.removeClass("ui-state-default").addClass("ui-state-highlight");
        else
            $bt.addClass("ui-state-default").removeClass("ui-state-highlight");
    }
};

ko.bindingHandlers.modelfieldspicker = {
    "init": function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        var res = ko.bindingHandlers.value.init(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);
        $(element).click(function () {
            //open the data field picker dialog.
            var modeloptions = Crimson.utils.value(allBindingsAccessor().modeloptions, {});
            var currentPaths = Crimson.utils.value(valueAccessor());
            var currentPath = null;
            if (Array.isArray(currentPaths)) {
                currentPath = currentPaths.length > 0 ? currentPaths[currentPaths.length - 1] : null;
            } else currentPath = currentPaths;

            modeloptions = $.extend({}, modeloptions, {
                "path": currentPath
            });
            var entity = modeloptions.root_entity;
            if (typeof entity == "function") {
                entity = entity();
            } else if (entity != null && entity[0] == "?") {
                modeloptions.root_entity = ko.utils.unwrapObservable(ko.dataFor($(element)[0])[entity.slice(1)]);
            }


            $.crimson.dialog({
                "url": "/model/exploredlg",
                "buttons": {
                    "Ok": function () {
                        $(this).dialog("close");
                    }
                }
            }, modeloptions).done(function (ev, data1, data) {
                var res = null;
                if (typeof data.viewdata != "undefined" && data.viewdata.path)
                    res = data.viewdata.path;
                else res = data.path;
                if (res) {
                    var cval = ($(element).val() || "").split(",");
                    var result = [];
                    $.each(cval, function (k, v) {
                        if (v != "" && v != null)
                            result.push(v);
                    });
                    result.push(res);
                    valueAccessor()(result);
                }
            });
        }).change(function () {
            var value = $(element).val();
            var cval = [];
            if (typeof value == "undefined" || !value)
                cval = [];
            cval = value.split(",");
            var result = [];
            $.each(cval, function (k, v) {
                if (v != "" && v != null)
                    result.push(v);
            });
            valueAccessor()(result);
        });
        return res;
    },
    "update": function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        var value = ko.toJS(ko.utils.unwrapObservable(valueAccessor()));
        if (!Array.isArray(value) && value)
            value = [value];
        if (typeof value == "undefined" || value == null || value == "")
            $(element).val("");
        else
            $(element).val(value.join(","));
    }
};

ko.bindingHandlers.modelexplorer = {
    "init": function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        $(element).empty();
        var current_path = ko.utils.unwrapObservable(valueAccessor());
        var treeoptions = allBindingsAccessor().treeoptions;
        if (typeof treeoptions == "undefined")
            treeoptions = {};
        else treeoptions = ko.utils.unwrapObservable(treeoptions);

        var modeloptions = allBindingsAccessor().modeloptions;
        if (typeof modeloptions == "undefined")
            modeloptions = {
                entity: "organisation"
            };
        else modeloptions = ko.utils.unwrapObservable(modeloptions);
        if (!modeloptions) {
            modeloptions = {
                entity: "organisation"
            };
        }

        var roots = ko.utils.unwrapObservable(modeloptions.roots);
        var root_entity = ko.utils.unwrapObservable(modeloptions.entity);
        //console.log("explorer: roots=", roots, "entity=", root_entity);
        var options = $.extend({
            core: {
                animation: 250,
                html_titles: false
            },
            themeroller: {
                item: ""
            },
            ui: {
                select_limit: 1
            },
            "json_data": {
                "ajax": {
                    "url": Crimson.root + "model/explore",
                    "data": function (n) {
                        return {
                            "__json": ko.toJSON($.extend({}, modeloptions, {
                                "path": n.data ? n.data("path") : null
                            }))
                        };
                    },
                    "success": function (data) {
                        var res = [];
                        $.each(data, function (k, node) {
                            //console.log("got node: ", node.path, " excluding:", modeloptions.exclude_path, " and this node is excluded?:", $.inArray(node.path, modeloptions.exclude_path));
                            if (0 > $.inArray(node.path, modeloptions.exclude_path)) {
                                if (node.is_rel) {
                                    if (node.multiplicity == "one" && modeloptions.show_single !== false) {
                                        res.push({
                                            "data": node.name,
                                            "metadata": {
                                                "path": node.path,
                                                "is_rel": true,
                                                "multiplicity": node.multiplicity,
                                                "entity": root_entity,
                                                "type": node.type
                                            },
                                            "state": modeloptions.traverse_single !== false ? "closed" : ""
                                        });
                                    } else if (node.multiplicity == "many" && modeloptions.show_many !== false) {
                                        res.push({
                                            "data": node.name,
                                            "metadata": {
                                                "path": node.path,
                                                "is_rel": true,
                                                "multiplicity": node.multiplicity,
                                                "entity": root_entity,
                                                "type": node.type
                                            },
                                            "state": modeloptions.traverse_many !== false ? "closed" : ""
                                        });

                                    }
                                } else if (modeloptions.show_attrs !== false)
                                    res.push({
                                        "data": node.name,
                                        "metadata": {
                                            "path": node.path,
                                            "is_rel": node.is_rel ? true : false,
                                            "multiplicity": node.multiplicity,
                                            "entity": root_entity,
                                            "type": node.type
                                        },
                                        "state": node.is_rel || node.has_kids ? "closed" : ""
                                    });
                            }
                        });
                        return res;
                    }
                }
            },
            "crrm": {
                "move": {
                    "check_move": function (m) {
                        return false;
                    },
                    "always_copy": "multitree"
                }
            },
            "dnd": {
                "drag_check": function () {
                    return false;
                }
            },
            plugins: ["dnd", "ui", "crrm", "json_data", "themeroller"]
        }, treeoptions);
        //console.log("options:", options, "entity:", root_entity);
        var deferred = Promise.Deferred();

        $(element).jstree(options).data("previous_root", root_entity || "").data("loading", deferred.promise());
        $(element).bind("move_node.jstree", function (ev, data) {
            //console.log("modelexplorer move_node:", ev, data);
        }).bind("select_node.jstree", function (ev, data) {
            var pathAccessor = valueAccessor();
            var node_data = $(element).jstree("get_selected").data();
            var path = node_data.path;
            var entity = node_data.entity;
            //console.log("select_node:", data, node_data);
            if (typeof pathAccessor == "function") {
                $(element).data("_changing", true);
                try {
                    pathAccessor(path);
                } finally {
                    $(element).data("_changing", false);
                }
            }
        }).bind("load_node.jstree", function (ev, data) {
            //console.log("node loaded", data);
            deferred.resolve(data);
        });
        return {
            "controlsDescendantBindings": true
        };
    },
    "update": function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        var changing = $(element).data("_changing");
        if (typeof changing != "undefined") {
            if (changing)
                return;
        }
        //if ((typeof changing != "undefined") && changing)
        //        return;
        var new_path = ko.utils.unwrapObservable(valueAccessor());

        var modeloptions = allBindingsAccessor().modeloptions;
        if (typeof modeloptions == "undefined")
            modeloptions = {
                entity: "organisation"
            };
        else modeloptions = ko.utils.unwrapObservable(modeloptions);
        if (!modeloptions) {
            modeloptions = {
                entity: "organisation"
            };
        }


        var new_root = ko.utils.unwrapObservable(modeloptions.entity);
        var old_root = $(element).data("previous_root");

        // console.log("modelexplorer update: new=", new_root, "old=", old_root);
        if (typeof old_root == "undefined" || old_root != new_root)
            ko.bindingHandlers.modelexplorer.init(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);
        var promise = $(element).data("loading");
        promise.done(function (node_data) {
            var spoptions = allBindingsAccessor().selectedPath;
            var selectedPath = new_path;
            if (selectedPath) {
                var tokens = selectedPath.split(".");
                // console.log("starting open cascade:", tokens);
                var cnode = null;
                var ctoken = "";
                var ctokenidx = 0;
                var func = function (openedNode) {
                    if (null == cnode) {
                        ctoken = tokens[ctokenidx];
                        var all_li = $(element).find("li");
                        var li = $.grep(all_li, function (l) {
                            return $(l).data("path") == ctoken;
                        });
                        cnode = li;
                        if (ctokenidx < tokens.length - 1) {
                            ctokenidx++;
                            $(element).jstree("open_node", li, func);
                        } else {
                            $(element).jstree("select_node", cnode);
                            return;
                        }
                    } else {
                        if (ctokenidx < tokens.length) {
                            var newtoken = tokens[ctokenidx];
                            ctoken = ctoken + "." + newtoken;
                            var li = $.grep($(cnode).find("li"), function (l) {
                                return $(l).data("path") == ctoken;
                            });
                            cnode = li;
                        }
                        if (ctokenidx == tokens.length - 1) {

                            $(element).jstree("select_node", cnode);
                            return;
                        } else {
                            ctokenidx++;
                            $(element).jstree("open_node", cnode, func);
                        }
                    }
                };
                func(null);
            }
        });
    }

};